import { inject, Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { NotificationService } from './notification.service';
import { TranslateService } from '@ngx-translate/core';

@Injectable({ providedIn: 'root' })
export class AuthService {
  private readonly n = inject(NotificationService);
  private readonly t = inject(TranslateService);

  private tokenSubject = new BehaviorSubject<string | null>(null);
  private userSubject = new BehaviorSubject<any | null>(null);

  token$: Observable<string | null> = this.tokenSubject.asObservable();
  user$: Observable<any | null> = this.userSubject.asObservable();

  constructor() {
    const token = localStorage.getItem('auth_token');
    const user = localStorage.getItem('user');
    if (token) this.tokenSubject.next(token);
    if (user) this.userSubject.next(JSON.parse(user));
  }

  get token(): string | null {
    return this.tokenSubject.value;
  }

  get isAuthenticated(): boolean {
    return !!this.tokenSubject.value;
  }

  setSession(token: string, user: any): void {
    localStorage.setItem('auth_token', token);
    localStorage.setItem('user', JSON.stringify(user));
    this.tokenSubject.next(token);
    this.userSubject.next(user);
  }

  clearSession(): void {
    localStorage.removeItem('auth_token');
    localStorage.removeItem('user');
    this.tokenSubject.next(null);
    this.userSubject.next(null);
    this.n.onSuccess(this.t.instant('User.SignOutSuccess'));
  }
}
